import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

import {catchError, tap} from 'rxjs/operators';
import {BehaviorSubject, Observable} from 'rxjs';
import {NGXLogger} from 'ngx-logger';

import {environment} from 'src/environments/environment';

import {BaseService} from '../services/base.service';
import {AgentEventSortFieldName, AgentsEventsPaginatedList, AgentsEventsSearch, SortDirection,} from 'src/swagger-gen/web-secured/models';

@Injectable({
  providedIn: "root",
})
export class AcquisitionLogRepo extends BaseService {
  baseUrl = environment.apiUrl;
  eventUrl = this.baseUrl + "/agents/events/";

  /** Alarms count */
  private count = new BehaviorSubject(0);
  readonly currentCount$ = this.count.asObservable();

  /** Current alarms list */
  private alarms = new BehaviorSubject([]);
  readonly currentAlarmsList$ = this.alarms.asObservable();

  readonly DEFAULT_ALARMS_LIMIT = "200";

  constructor(private logger: NGXLogger, private httpClient: HttpClient) {
    super();
  }

  /**
   * Get all active alarms
   */
  getAcquisitionLogs(
    body: AgentsEventsSearch,
    limit?: number,
    offset?: number,
    startDateTime: string = '',
    endDateTime: string = '',
    sortFieldName: AgentEventSortFieldName = AgentEventSortFieldName.DATE,
    sortDirection: SortDirection = SortDirection.ASC,
    search: string = '',
  ): Observable<AgentsEventsPaginatedList> {
    const searchAlarmsUrl = this.eventUrl + "search";
    const paging = this.pagination(offset, limit, this.DEFAULT_ALARMS_LIMIT);

    let requestString: string;
    requestString = paging;
    requestString += `&startDateTime=${startDateTime}`;
    requestString += `&endDateTime=${endDateTime}`;
    requestString += `&sortFieldName=${sortFieldName}`;
    requestString += `&sortDirection=${sortDirection}`;
    requestString += `&search=${search}`;
    const requestParams = new HttpParams({ fromString: requestString });
    const httpOptions = {
      headers: this.httpHeaders(),
      params: requestParams,
    };

    return this.httpClient
      .post<AgentsEventsPaginatedList>(searchAlarmsUrl, body, httpOptions)
      .pipe(
        tap((events: AgentsEventsPaginatedList) => {
          this.logger.log(`Got ${events.paging.totalItems} logs in service.`);
        }), // DEBUG
        catchError(this.handleServerError)
      );
  }
}
